import colors from '@/colors/colors.module.scss';
import store from '@/store';

// Licensed Typotheque hosted webfont (project WF-027963-009352). The editor renders
// content in an iframe, so the <link> in the page shell does not reach it: it has to be
// pulled in through content_css as well.
export const TYPOTHEQUE_FEDRA_CSS = 'https://fonts.typotheque.com/WF-027963-009352.css';

export const TINY_FONTFORMATS = [
  'Roboto=Roboto,sans-serif',
];

export const TINY_PLUGINS = [
  'advlist',
  'anchor',
  'autolink',
  'charmap',
  'code',
  'emoticons',
  'editimage',
  'fullscreen',
  'help',
  'image',
  'importcss',
  'link',
  'lists',
  'media',
  'nonbreaking',
  'pagebreak',
  'powerpaste',
  'preview',
  'quickbars',
  'save',
  'searchreplace',
  'table',
  'template',
  'visualblocks',
  'visualchars',
  'wordcount',
  'tableofcontents',
];

export const TINY_MENUBAR = [
  'file',
  'edit',
  'view',
  'insert',
  'format',
  'tools',
  'table',
  'help',
];

export const TINY_TOOLBAR = [
  'template',
  '|',
  'tableofcontents',
  '|',
  'undo',
  'redo',
  '|',
  'speak',
  '|',
  'bold',
  'italic',
  'underline',
  'strikethrough',
  '|',
  'fontsizeselect',
  'formatselect',
  '|',
  'alignleft',
  'aligncenter',
  'alignright',
  'alignjustify',
  '|',
  'outdent',
  'indent',
  '|',
  'numlist',
  'bullist',
  '|',
  'forecolor',
  'backcolor',
  'removeformat',
  '|',
  'insertfile',
  'image',
  'media',
];

export const TINY_QUICKBAR = [
  'bold',
  'italic',
  '|',
  'quicklink',
  'h2',
  'h3',
  'blockquote',
  'quickimage',
  'quicktable',
  '|',
  'speak',
];

export const TINY_INIT = {
  branding: false,
  content_css: ['default', TYPOTHEQUE_FEDRA_CSS],
  content_style: `body { font-family: Roboto,sans-serif; background: ${colors.$greyLighten5} } .mce-content-body .g-layout__container { margin: -1rem;width: calc(100% + 2rem); } .fedra-sans { font-family: 'Fedra Sans'; }`,
  font_formats: TINY_FONTFORMATS.join('; '),
  image_advtab: true,
  image_caption: true,
  paste_data_images: true,
  powerpaste_googledocs_import: 'clean',
  powerpaste_word_import: 'clean',
  quickbars_selection_toolbar: TINY_QUICKBAR.join(' '),
  quickbars_image_toolbar: 'alignleft aligncenter alignright | speak',
  menubar: TINY_MENUBAR.join(' '),
  resize: false,
  toolbar: TINY_TOOLBAR.join(' '),
  toolbar_mode: 'floating',
  toolbar_sticky: true,
  visual: false,
  contextmenu: false,
  browser_spellcheck: true,
  extended_valid_elements: 'span[*],link[href|rel]',
  custom_elements: 'link',
  noneditable_editable_class: 'mceEditable',
  automatic_uploads: false,
  media_live_embeds: true,
  images_upload_handler(blobInfo, success) {
    success(`data:${blobInfo.blob().type};base64,${blobInfo.base64()}`);
  },
};

export const LINK_INIT = {
  link_assume_external_targets: true,
  link_default_protocol: 'https',
  default_link_target: '_blank',
  relative_urls: false,
  convert_urls: false,
  link_title: false,
  target_list: [
    { title: 'New window', value: '_blank' },
  ],

  paste_postprocess(editor, args) {
    [...args.node.querySelectorAll('a[href]')].forEach((link) => {
      link.setAttribute('target', '_blank');
      link.setAttribute('rel', 'noopener');

      const isEnhancedPasteEnabled = store.state.launchDarkly?.flags?.['youtube-153-error'];
      if (!isEnhancedPasteEnabled) return;

      const url = link.getAttribute('href');
      const ytMatch = url.match(
        /(?:youtube\.com\/watch\?v=|youtu\.be\/)([A-Za-z0-9_-]{11})/,
      );
      if (!ytMatch) return;

      const videoId = ytMatch[1];
      const thumbUrl = `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;
      const placeholderId = `yt-thumb-${Date.now()}-${Math.random()}`;
      const placeholder = editor.getDoc().createElement('span');
      placeholder.setAttribute('id', placeholderId);
      placeholder.innerText = 'Loading preview…';
      link.replaceWith(placeholder);

      const doc = editor.getDoc();
      const wrapper = doc.createElement('a');
      wrapper.href = url;
      wrapper.target = '_blank';
      wrapper.rel = 'noopener';

      const container = doc.createElement('span');
      container.style.position = 'relative';
      container.style.display = 'inline-block';

      const img = doc.createElement('img');
      img.src = thumbUrl;
      img.alt = 'YouTube thumbnail';
      img.style.maxWidth = '100%';
      img.style.cursor = 'pointer';

      const play = doc.createElement('span');
      play.style.position = 'absolute';
      play.style.top = '50%';
      play.style.left = '50%';
      play.style.transform = 'translate(-50%, -50%)';
      play.style.width = '80px';
      play.style.height = '80px';
      play.style.background = 'rgba(0,0,0,0.45)';
      play.style.borderRadius = '50%';
      play.style.display = 'flex';
      play.style.alignItems = 'center';
      play.style.justifyContent = 'center';
      play.style.pointerEvents = 'none';

      const triangle = doc.createElement('span');
      triangle.style.position = 'absolute';
      triangle.style.top = '50%';
      triangle.style.left = '50%';
      triangle.style.transform = 'translate(-40%, -50%)';
      triangle.style.width = '0';
      triangle.style.height = '0';
      triangle.style.borderTop = '18px solid transparent';
      triangle.style.borderBottom = '18px solid transparent';
      triangle.style.borderLeft = '28px solid white';
      triangle.style.pointerEvents = 'none';

      play.appendChild(triangle);

      container.appendChild(img);
      container.appendChild(play);
      wrapper.appendChild(container);

      const ph = doc.getElementById(placeholderId);
      if (ph) ph.replaceWith(wrapper);
    });
  },
};
